import api from 'ApiConfig';

const attendanceService = {
  submitAttendance: async (payload) => {
    return api.post('/teacher/submit-attendance', payload);
  },
  markStudentAttendance: async (teacherId, classId, studentsIds, date) => {
    return api.post('/teacher/submit-attendance', {
      teacherId,
      classId,
      studentsIds,
      date,
    });
  },
  getPeriods: async (teacherId, standard, division) => {
    return api.post('/teacher/get-today-timetable', {
      teacherId,
      standard,
      division,
    });
  },
  lecturewiseAttendance: async (
    teacherId,
    classId,
    absentStudents,
    periodIndex,
    day
  ) => {
    return api.post('/teacher/lecturewise-attendance', {
      teacherId,
      classId,
      absentStudents,
      periodIndex,
      day,
    });
  },
  getSubjectsData: async (teacherId, standard, division) => {
    return api.post('/teacher/get-subjects-data', {
      teacherId,
      standard,
      division,
    });
  },
  getlecturewiseAttendance: async (teacherId, date, classId, subjectId) => {
    return api.post('/teacher/get-lecturewise-attendance', {
      teacherId,
      date,
      classId,
      subjectId,
    });
  },
  getStudentAttendanceReport: async (payload) => {
    return api.post('/teacher/attendance-report', payload);
  },
  updateAttendance: async (payload) => {
    console.log(payload, 'load');
    return api.post('/teacher/update-attendance', payload);
  },

  getMarkedAttendanceDates: async (courseId, batchId) => {
    return api.post('/teacher/attendance-date', { courseId, batchId });
  },

  getCompleteAttendanceForDate: (courseId, batchId, date) => {
    return api.post('/teacher/get-complete-attendance-for-date', {
      courseId,
      batchId,
      date,
    });
  },
  createLectureSession: (data) => {
    return api.post('/teacher/create-lecture-session', data);
  },

  getLectureProgress: (courseId, batchId) => {
    return api.get('/teacher/lecture-progress', {
      params: { courseId, batchId },
    });
  },

  getSentTopics: (courseId, batchId) => {
    return api.get('/teacher/get-sent-topics', {
      params: { courseId, batchId },
    });
  },

  getBulkAttendanceData: (courseId, batchId, fromDate, toDate) => {
    return api.post('/teacher/get-bulk-attendance-data', { courseId, batchId, fromDate, toDate });
  },

  bulkSubmitAttendance: (payload) => {
    return api.post('/teacher/bulk-submit-attendance', payload);
  },
};
export default attendanceService;
